import { render, staticRenderFns } from "./PSQI.vue?vue&type=template&id=5f52d6ec&scoped=true&"
import script from "./PSQI.vue?vue&type=script&lang=js&"
export * from "./PSQI.vue?vue&type=script&lang=js&"
import style0 from "./PSQI.vue?vue&type=style&index=0&id=5f52d6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52d6ec",
  null
  
)

export default component.exports